module.exports = __webpack_public_path__ + "static/img/logo-INS.dec2490.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/logo-INS.png
// module id = wJbJ
// module chunks = 1